export default function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_isFunction.js
// module id = 107
// module chunks = 2 3 4 5 6 7 8 10